import { gateway } from "../../../../gateway";

export const getSupplyId = async ({ token, id }) => {
  try {
    const res = await gateway.get(
      `/supplies/item/${id}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
